module.exports = __webpack_public_path__ + "img/moses-yale-beach.4aa66cc9.png";